import { Outlet } from "react-router-dom";
import { SmoothScroll } from "./SmoothScroll";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppButton } from "@/components/shared/WhatsAppButton";

export const Layout = () => (
  <SmoothScroll>
    <Navbar />
    <main id="main" className="relative">
      <Outlet />
    </main>
    <Footer />
    <WhatsAppButton />
  </SmoothScroll>
);
